import { z } from 'zod';
/** One Entra AD group → one Orion role, evaluated in array order at every
 * sign-in ("highest role wins" — design/orion-crm-design/rendered-html/
 * AdminSSO.html). `entraGroupId` is whatever the ID token's `groups` claim
 * carries — normally the group's object ID, a name only if the admin
 * configured Entra to emit group names instead. */
export const entraRoleMappingSchema = z.object({
    entraGroupId: z.string().trim().min(1).max(200),
    roleId: z.string().uuid(),
});
/** docs/architecture/05-authentication.md § Entra SSO. The client *secret*
 * is never stored here or sent to the browser — only in Doppler
 * (`ENTRA_CLIENT_SECRET`); this config is everything else needed to build
 * the authorization request and decide how to provision the signed-in
 * user. */
export const entraConfigSchema = z.object({
    enabled: z.boolean().default(false),
    entraTenantId: z.string().trim().min(1).nullable(),
    clientId: z.string().trim().min(1).nullable(),
    allowedTenants: z.enum(['single', 'organizations']).default('single'),
    jitEnabled: z.boolean().default(true),
    defaultRoleId: z.string().uuid().nullable(),
    linkByVerifiedEmail: z.boolean().default(true),
    roleMappings: z.array(entraRoleMappingSchema).default([]),
});
export const entraConfigResponseSchema = entraConfigSchema.extend({
    secretConfigured: z.boolean(),
    lastTestAt: z.string().datetime().nullable(),
    lastTestOk: z.boolean().nullable(),
});
export const entraTestResultSchema = z.object({ ok: z.boolean(), message: z.string(), testedAt: z.string().datetime() });
export const ssoHealthResponseSchema = z.object({
    signInsLast24h: z.number().int(),
    failedLast24h: z.number().int(),
    usersLinked: z.number().int(),
    totalActiveUsers: z.number().int(),
    lastSignInAt: z.string().datetime().nullable(),
});
export const tenantDomainResponseSchema = z.object({
    id: z.string().uuid(),
    domain: z.string(),
    verifiedAt: z.string().datetime().nullable(),
    ssoRequired: z.boolean(),
    /** Present only when unverified — what to publish as a DNS TXT record to
     * prove ownership. Never sent once `verifiedAt` is set. */
    verificationToken: z.string().nullable(),
});
export const addDomainSchema = z.object({ domain: z.string().trim().toLowerCase().min(3).max(253) });
//# sourceMappingURL=sso.js.map